import {ActionKeys, CreateValue} from "../Ability";
import {getMe} from "../../../api/system/admin/user-account";

export const ShiftWorkAbility = ({can: allow, cannot: notAllow, rules}, {isAdmin, isSystem}, subWorkspace) => {
    const key = subWorkspace.key
    const isCreate = subWorkspace?.create?.createValue === CreateValue.TRUE
    const isView = subWorkspace?.enable
    const belongCondition = (conditionObject) => {
      return  conditionObject?.creatorId === getMe()?.accountId
    } // check la nguoi tao ca


    allow([ActionKeys.READ], key, () => isView)
    allow(ActionKeys.CREATE, key, () => isCreate)
    allow(ActionKeys.DELETE, key, (conditionObject) => {
     return   isCreate && conditionObject.status === "draft"
    })
    allow(ActionKeys.UPDATE, key, (conditionObject) => {
      return  isCreate && conditionObject.status === "draft"
    })
    allow(ActionKeys.RECALL, key, (conditionObject) => {
      return  !conditionObject?.hiddenRecall && conditionObject.status !== "draft" &&
        conditionObject?.status !== "approved" &&
        conditionObject?.status !== "denied"
    })
}

export const SalaryAbility = ({can: allow, cannot: notAllow, rules}, {isAdmin, isSystem}, subWorkspace) => {
    const key = subWorkspace.key
    const isCreate = subWorkspace?.create?.createValue === CreateValue.TRUE
    const isView = subWorkspace?.enable
    const belongCondition = (conditionObject) => {
        return  conditionObject?.creatorId === getMe()?.accountId || (conditionObject?.creatorId === 0 ) // && getMe()?.adminAccount === true
    }


    allow([ActionKeys.READ], key, () => isView)
    allow(ActionKeys.CREATE, key, () => isCreate)
    allow(ActionKeys.DELETE, key, (conditionObject) => {
        return   isCreate && conditionObject.status === "draft" && belongCondition(conditionObject)
    })
    allow(ActionKeys.UPDATE, key, (conditionObject) => {
        return  isCreate && conditionObject.status === "draft" && belongCondition(conditionObject)
    })
    allow(ActionKeys.RECALL, key, (conditionObject) => {
        return  !conditionObject?.hiddenRecall && conditionObject.status !== "draft" &&
            conditionObject?.status !== "approved" &&
            conditionObject?.status !== "denied" && belongCondition(conditionObject)
    })
}

